((() => {
  'use strict';
  
  let liveRegion = document.getElementById('boost-search-suggestions-announcer');
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'boost-search-suggestions-announcer';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.style.position = 'absolute';
    liveRegion.style.left = '-10000px';
    liveRegion.style.width = '1px';
    liveRegion.style.height = '1px';
    liveRegion.style.overflow = 'hidden';
    document.body.appendChild(liveRegion);
  }
  
  const lastAnnouncedCount = {};
  let debounceTimer = null;
  let processingCheck = false;
  
  const announceSuggestions = (wrapperId, count) => {
    if (count > 0) {
      if (lastAnnouncedCount[wrapperId] === count) {
        return;
      }
      
      const message = count === 1 
        ? '1 search suggestion loaded' 
        : count + ' search suggestions loaded';
      
      liveRegion.textContent = message;
      lastAnnouncedCount[wrapperId] = count;
    }
  };
  
  const checkWrapper = (wrapper, index) => {
    const wrapperId = wrapper.getAttribute('data-search-box-id') || 'wrapper-' + index;
    const isOpen = wrapper.classList.contains('boost-pfs-search-suggestion-open');
    
    if (isOpen) {
      const suggestionItems = wrapper.querySelectorAll('.boost-pfs-search-suggestion-item:not(.boost-pfs-search-suggestion-loading):not(.boost-pfs-search-suggestion-no-result)');
      const isLoading = wrapper.querySelector('.boost-pfs-search-suggestion-loading');
      
      if (isLoading) {
        return;
      }
      
      if (suggestionItems.length > 0) {
        announceSuggestions(wrapperId, suggestionItems.length);
      }
    } else {
      if (lastAnnouncedCount[wrapperId] !== undefined) {
        delete lastAnnouncedCount[wrapperId];
      }
    }
  };
  
  const debouncedCheckWrappers = () => {
    if (processingCheck) {
      return;
    }
    
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    debounceTimer = setTimeout(() => {
      processingCheck = true;
      
      const wrappers = document.querySelectorAll('.boost-pfs-search-suggestion-wrapper');
      
      if (wrappers.length > 0) {
        wrappers.forEach((wrapper, index) => {
          checkWrapper(wrapper, index);
        });
      }
      
      processingCheck = false;
    }, 200);
  };
  
  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;
    
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      const target = mutation.target;
      
      const isInSuggestionWrapper = target.classList && 
          (target.classList.contains('boost-pfs-search-suggestion-wrapper') ||
           target.classList.contains('boost-pfs-search-suggestion') ||
           target.classList.contains('ui-autocomplete') ||
           target.closest('.boost-pfs-search-suggestion-wrapper'));
      
      if (isInSuggestionWrapper) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (target.classList.contains('boost-pfs-search-suggestion-open')) {
            shouldCheck = true;
            break;
          }
        }
        
        if (mutation.type === 'childList') {
          if (mutation.addedNodes.length > 0) {
            for (let j = 0; j < mutation.addedNodes.length; j++) {
              const node = mutation.addedNodes[j];
              if (node.nodeType === 1) {
                const hasItems = node.classList && 
                              (node.classList.contains('boost-pfs-search-suggestion-item') ||
                               node.classList.contains('boost-pfs-search-suggestion-group') ||
                               node.querySelector('.boost-pfs-search-suggestion-item'));
                
                if (hasItems) {
                  shouldCheck = true;
                  break;
                }
              }
            }
          }
          
          if (mutation.removedNodes.length > 0 && !shouldCheck) {
            for (let k = 0; k < mutation.removedNodes.length; k++) {
              const removedNode = mutation.removedNodes[k];
              if (removedNode.nodeType === 1) {
                const hadItems = removedNode.classList && 
                               (removedNode.classList.contains('boost-pfs-search-suggestion-item') ||
                                removedNode.classList.contains('boost-pfs-search-suggestion-group'));
                
                if (hadItems) {
                  shouldCheck = true;
                  break;
                }
              }
            }
          }
        }
      }
      
      if (shouldCheck) break;
    }
    
    if (shouldCheck) {
      debouncedCheckWrappers();
    }
  });
  
  const startObserving = () => {
    const targetNode = document.body;
    const config = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    };
    
    observer.observe(targetNode, config);
    
    const existingWrappers = document.querySelectorAll('.boost-pfs-search-suggestion-wrapper.boost-pfs-search-suggestion-open');
    if (existingWrappers.length > 0) {
      existingWrappers.forEach((wrapper, index) => {
        checkWrapper(wrapper, index);
      });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
  
  window.addEventListener('beforeunload', () => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    observer.disconnect();
  });
})());